import { Field } from 'formik';
import { FormikRadioGroup, FormikTextInput } from '@flexinet/ui-components';

const statusOptions = [
    { value: '', label: 'All Statuses' },
    { value: 'Active', label: 'Active' },
    { value: 'Inactive', label: 'Inactive' },
    { value: 'Draft', label: 'Draft' },
    { value: 'Deprecated', label: 'Deprecated' },
];

export const FilterFormComponent = () => {
    return (
        <>
            <Field
                name="status"
                label="Status"
                data={statusOptions}
                component={FormikRadioGroup}
                my="md"
            />
            <Field
                name="category"
                label="Category"
                placeholder="e.g. Storage, Compute"
                component={FormikTextInput}
                my="md"
            />
        </>
    );
};
